import { RouteType } from "types/RouteType";
import PurchasingRoute from "./Purchasing.Route";
import QuoteGenerationRoute from "./QuoteGeneration.Route";
import SalesOrderConversionRoute from "./SalesOrderConversion.Route";

const purchasingRoutesList: RouteType[] = [
  PurchasingRoute,
  QuoteGenerationRoute,
  SalesOrderConversionRoute,
];

export default purchasingRoutesList;